import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  // user_id state
  const [userId, setUserId] = useState(() => {
    const storedUserId = localStorage.getItem("user_id");
    return storedUserId ? storedUserId : null;
  });

  // sessionId state
  const [sessionId, setSessionId] = useState(() => {
    const storedSessionId = localStorage.getItem("session_token");
    return storedSessionId ? storedSessionId : null;
  });

  // Persist userId
  useEffect(() => {
    if (userId) {
      localStorage.setItem("user_id", userId);
    } else {
      localStorage.removeItem("user_id");
    }
  }, [userId]);

  // Persist sessionId
  useEffect(() => {
    if (sessionId) {
      localStorage.setItem("session_token", sessionId);
    } else {
      localStorage.removeItem("session_token");
    }
  }, [sessionId]);

  // Sync userId across all tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "user_id") {
        setUserId(e.newValue);
      }
      if (e.key === "session_token") {
        setSessionId(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // login function now sets both userId and sessionId
  const login = (id, session) => {
    setUserId(id);
    setSessionId(session);
  };

  const logout = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("session_token");
    setUserId(null);
    setSessionId(null);
  };

  return (
    <AuthContext.Provider value={{ userId, sessionId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
